import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { client, unwrap, type components } from '../../api'

/**
 * Patient profile / intake record. Generated from `openapi.yaml`
 * (`PatientIntake` schema) — the field-by-field interface that used to live
 * here is now the single source of truth in the spec.
 */
export type ProfileData = components['schemas']['PatientIntake']

export function useProfile() {
  return useQuery({
    queryKey: ['patient', 'profile'],
    queryFn: () => unwrap(client.GET('/api/patient/profile')),
    staleTime: 60_000,
  })
}

export function useSaveProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: ProfileData) =>
      unwrap(client.PUT('/api/patient/profile', { body: data })),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patient', 'profile'] })
      queryClient.invalidateQueries({ queryKey: ['patient', 'intake'] })
      queryClient.invalidateQueries({ queryKey: ['patient', 'dashboard'] })
      // Editing LMP ranges / cycle length here changes the cycle prediction,
      // so refetch it rather than waiting out the predictor's staleTime.
      queryClient.invalidateQueries({ queryKey: ['patient', 'cycle-predictor'] })
      queryClient.invalidateQueries({ queryKey: ['patient', 'calendar'] })
    },
  })
}
